import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, DatePicker, Input, message, Row, Select, Spin, Switch } from 'antd';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import { useNavigate, useParams } from 'react-router-dom';
import UploadComponent from '../upload/UploadComponent';
import DragUploadPrivateComponentPdf from '../upload/DragUploadPrivateComponentPdf';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import { FASHION_URL } from '../../api/URLs';
import HeaderMagazineComponent from '../header/HeaderMagazineComponent';
import dayjs from 'dayjs';
import _ from 'lodash';
import TextAreaComponent from '../input/TextAreaComponent';

function FashionUpload() {
    const { t } = useTranslation();
    const messageModalRef = useRef("");
    const navigate = useNavigate();
    const { id } = useParams();
    const [picUrl, setpicUrl] = useState("")
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [oldValue, setOldValue] = useState({
        title: "",
        status: false,
        picUrl: "", // cover
        releaseYear: "",
        description: "",
        privateFile: {
            url: "",
            size: "",
            fileName: "",
            page: 0
        }
    });
    const [dataObject, setDataObject] = useState({
        title: "",
        status: false,
        picUrl: "", // cover
        releaseYear: "",
        description: "",
        privateFile: {
            url: "",
            size: "",
            fileName: "",
            page: 0
        }
    });
    const [privateFile, setPrivateFiles] = useState([]);

    const addNewValue = async (data) => {
        setpicUrl(data.picUrl);
        let objectValue = {
            ...dataObject,
            title: data.title,
            status: data.status,
            picUrl: data.picUrl,
            description: data.description,
            releaseYear: data.releaseYear,
            privateFile: {
                url: data.privateFile?.url,
                size: data.privateFile?.size,
                fileName: data.privateFile?.fileName,
                page: data.privateFile?.page
            }
        };

        setDataObject({...objectValue})

        setOldValue({...objectValue});

        setPrivateFiles([{
            "url": data.privateFile?.url ?? "",
            "size": data.privateFile?.size ?? "",
            "name": data.privateFile?.fileName ?? "",
            "uid": data.privateFile?.uploadedTS,
            "page": data.privateFile?.page ?? undefined
        }]);
    }

    const getDetailById = async () => {
        if (!id) { return; }
        return await getDataRequest(`${FASHION_URL}/${id && id}`)
            .then((res) => {
                if (res.status === 200) {
                    addNewValue(res.data)
                }
            })
    }

    const getDataRequestAll = async (value) => {
        try {
            setLoading(true);
            await Promise.all([ getDetailById()]);
        } catch (error) {
            setLoading(false);
            message.error('Server Error!');
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getDataRequestAll()
    }, [])

    const checkError = () => {
        if (
            !dataObject.picUrl ||
            !dataObject.privateFile.url ||
            !dataObject.title ||
            !dataObject.releaseYear ||
            !dataObject.description
        ) {
            return true
        }
        return false
    }

    //not support array type yet
    const insertChangedValue = (data, oldData) => {
        let changedValue = {};
        Object.keys(data).forEach((key) => {
            if (_.isArray(data[key])) {
                if (_.difference(data[key], oldData[key]).length > 0 || _.difference(oldData[key], data[key]).length > 0) {
                    changedValue[key] = data[key];
                }
            } else if (_.isObject(data[key])) {
                if (Object.keys(insertChangedValue(data[key], oldData[key])).length > 0) {
                    changedValue[key] = data[key];
                }
            } else if (!_.isEqual(data[key], oldData[key])) {
                changedValue[key] = data[key];
            }
        })
        return changedValue;
    }

    const insertParams = () => {
        return {
            "title": dataObject.title,
            "status": dataObject.status,
            "picUrl": dataObject.picUrl, // cover
            "releaseYear": dataObject.releaseYear,
            "description": dataObject.description,
            "privateFile": {
                "url": dataObject.privateFile?.url,
                "size": dataObject.privateFile?.size,
                "fileName": dataObject.privateFile?.fileName,
                "page": dataObject.privateFile?.page
            }
        }
    }
    const handleSubmit = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setIsSubmit(false)
        setLoading(true);
        const params = insertParams()

        try {
            const res = await postDataRequest(FASHION_URL, params);
            if (res?.status === 200) {
                messageModalRef.current.showSuccessConfirmsAutoClose(res.data?.message || t("Saved Successfully"), () => { }, "", true);
                setTimeout(() => {
                    navigate(`/fashion`)
                }, 2000);
            } else {
                messageModalRef.current.showWarningConfirmsAutoClose(res.data?.message || res.message || t("An error occurred."), () => { }, "", true);
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response?.data && err.response?.data?.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
        }
    }

    const hadleUpdate = async () => {
        setIsSubmit(true)
        if (checkError()) {
            return false
        }
        setIsSubmit(false)
        setLoading(true);
        let params = insertParams();
        params = insertChangedValue(params, oldValue);
        try {
            if (!_.isEmpty(params)) {
                const res = await putDataRequest(`${FASHION_URL}/${id}`, params);
                if (res?.status === 200) {
                    messageModalRef.current.showSuccessConfirmsAutoClose(res.data?.message || t("Saved Successfully"), () => { }, "", true);
                    setTimeout(() => {
                        navigate(`/fashion`)
                    }, 2000);
                } else {
                    messageModalRef.current.showWarningConfirmsAutoClose(res.data?.message || res.message || t("An error occurred."), () => { }, "", true);
                }
            } else {
                messageModalRef.current.showSuccessConfirmsAutoClose(t("No changes to Data!"), () => { }, "", true);
                setTimeout(() => {
                    navigate(`/fashion`)
                }, 2000);
            }
        } catch (err) {
            messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
        } finally {
            setLoading(false);
        }
    }

    const handleChangeValue = (e) => {
        setDataObject((v) => ({ ...v, [e.target.name]: e.target.value ?? "" }));
    }

    const handleChangeStatus = (value) => {
        setDataObject((v) => ({ ...v, status: value }));
    }

    const handleChangeDate = (value) => {
        setDataObject((v) => ({ ...v, releaseYear: value !== null ? dayjs(value).format("YYYY") : "" }));
    }

    const handleChangePrivateFile = (value) => {
        setPrivateFiles(value);
        setDataObject((v) => ({
            ...v,
            privateFile: {
                "url": value[0]?.url ?? "",
                "size": value[0]?.size ?? "",
                "fileName": value[0]?.name ?? "",
                "page": value[0]?.page ?? 0
            }
        }));
    }

    const handleChangeCover = (value) => {
        setpicUrl(value.url)
        setDataObject((v) => ({
            ...v,
            picUrl: value.url
        }));
    }


    return (
        <>
            <HeaderMagazineComponent
                backgroundColor="#E50A47"
                border="1px solid #e72158"
                isHide="view"
                onClick={() => navigate('/fashion')}
                backTitle={t("Upload Fashion")}
                hideTitle="userDetails"
                bntTitle1={t("Submit")}
                opacity="0.5px"
                color="#FFFFFF"
                onClick1={() => {
                    !id ? handleSubmit() : hadleUpdate();
                }}
            >
                <Spin spinning={loading} fullscreen></Spin>
                <div className='container newDetail'>
                    <Row>
                        <Col md={5}>
                            <UploadComponent
                                fileList={picUrl ? [{
                                    "uid": "1",
                                    "name": "",
                                    "status": "done",
                                    "url": picUrl
                                }] : []}
                                uploadavatarTitle={t("Upload Cover")}
                                changeAvatarTitle={t("Change Cover")}
                                setFileList={handleChangeCover}
                            />
                        </Col>
                        <Col md={19}>
                            <Row>
                                <Card className='w-100'>
                                    <DragUploadPrivateComponentPdf
                                        privateFile={true}
                                        previewUrl={picUrl}
                                        fileList={privateFile}
                                        setFileList={handleChangePrivateFile}
                                        maxSize={50}
                                    />
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Title')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <Input
                                                value={dataObject.title}
                                                placeholder=""
                                                size="large"
                                                name='title'
                                                status={isSubmit && !dataObject.title && `error`}
                                                onChange={handleChangeValue}
                                                style={{
                                                    width: "100%"
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Year')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <DatePicker
                                                placeholder=''
                                                picker="year"
                                                onChange={handleChangeDate}
                                                format="YYYY年"
                                                value={dataObject.releaseYear ? dayjs().year(dataObject.releaseYear) : null}
                                                status={isSubmit && !dataObject.releaseYear && `error`}
                                                size="large"
                                                style={{ width: "50%" }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Description')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <TextAreaComponent status={isSubmit && !dataObject.description ? "error" :""} value={dataObject.description} setValue={(value) => setDataObject({ ...dataObject, description: value })} />
                                        </Col>
                                    </Row>
                                    <Row align="middle" className='mt-3'>
                                        <Col md={6} span={5} className='userLabel'>{t('Status')}:</Col>
                                        <Col md={18} className="text-capitalize">
                                            <Switch
                                                onChange={handleChangeStatus}
                                                value={dataObject.status}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </HeaderMagazineComponent>
            <MessageConfirmModal textCentered ref={messageModalRef} />
        </>
    );
}

export default FashionUpload;
